import { useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const StyledTabContainer = styled.div`
  display: flex;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.textDisabled};
  margin-bottom: 32px;
`

const StyledTab = styled.button<{ active?: boolean }>`
  flex: 1;
  padding: 12px 0;
  border: none;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  color: ${({ theme, active }) =>
    active ? theme.colors.textTitle : theme.colors.textCaption};

  ${({ active, theme }) =>
    active &&
    `
      &::after {
        content: '';
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
        height: 2px;
        background: ${theme.colors.primary};
      }
    `}

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.textTitle};
  }
`

const tabs = ['stake', 'wrap', 'withdrawal'] as const
type TabType = typeof tabs[number]

interface TabsProps {
  currentTab: TabType
}

const Tabs: React.FC<TabsProps> = ({ currentTab }) => {
  const { t } = useTranslation()
  const router = useRouter()

  const [activeTab, setActiveTab] = useState<TabType>(currentTab)

  const handleTabChange = (tab: TabType) => {
    if (tab !== currentTab) {
      setActiveTab(tab)
      const from = tab === 'withdrawal' ? 'withdraw' : tab
      router.push(`/staking/lido/${tab}?from=${from}`)
    }
  }

  return (
    <StyledTabContainer>
      {tabs.map((tab) => (
        <StyledTab
          key={tab}
          active={activeTab === tab}
          onClick={() => handleTabChange(tab)}
        >
          {t(`lido_${tab}_tab_title`)}
        </StyledTab>
      ))}
    </StyledTabContainer>
  )
}

export default Tabs
